// extracted by mini-css-extract-plugin
export default {"headerContainer":"home_headerContainer__XBSq7","headerImage":"home_headerImage__PBsi9"};